module.exports = __webpack_public_path__ + "media/images/favicons/impactcorps-97ba72e429ed6583f54136ea4669b7f926d55930cda9b88c533a3b5eee568514.ico";